<input
  [id]="jsonControl.id"
  [name]="jsonControl.name"
  [type]="jsonControl.field.type ?? 'text'"
  [value]="jsonControl.field.default_value ?? ''"
  [required]="jsonControl.field.required ?? false"
  [readonly]="jsonControl.field.readonly ?? false"
  [pattern]="jsonControl.field.pattern ?? ''"
  [placeholder]="jsonControl.field.placeholder ?? ''"
  [attr.aria-describedby]="'helpId-' + jsonControl.id"
  [minlength]="jsonControl.field.min ?? ''"
  [maxlength]="jsonControl.field.max ?? ''"
  [formControl]="control"
  class="form-control tas-form-control bg-white"
/>